import { schema, normalize } from 'normalizr';
import { User, Role } from './types';

const customer = new schema.Entity('customers');
const user = new schema.Entity('users');
const userRoles = new schema.Entity('userRoles');

export const normalizeCustomers = (data: any) => normalize(data, [customer]);
export const normalizeUsers = (users: Array<User>) => normalize(users, [user]);
export const normalizeUserRoles = (data: Array<Role>) =>
  normalize(data, [userRoles]);

/**
 * Filters list of users by search query.
 * @param {array} users - Array of users.
 * @param {string} searchStr - Search request string.
 * @return {array} - Array of filtered users
 */
export const filterUsers = (users: Array<User>, searchStr: string) =>
  users.filter(
    (usr) =>
      (usr.username && usr.username.includes(searchStr)) ||
      (usr.first_name && usr.first_name.includes(searchStr)) ||
      (usr.last_name && usr.last_name.includes(searchStr)) ||
      (usr.email && usr.email.includes(searchStr))
  );

/**
 * Filters list of roles by search query.
 * @param {object} roles - Roles object with data.
 * @param {string} searchStr - Search request string.
 * @return {object} - ROles object with array of filtered roles
 */
export const filterRoles = (
  // roles: { data: Array<Role> },
  roles: Array<Role>,
  searchStr: string
) => {
  const filteredRoles = roles.filter(
    (r) =>
      (r.name && r.name.includes(searchStr)) ||
      (r.description && r.description.includes(searchStr))
  );

  return { total: filteredRoles.length, data: filteredRoles };
};

/**
 * Normalizes user before saving via api
 * @param {object} userData - user data object.
 * @param {boolean} addRoles - add roles
 * @param {boolean} addEmail - add email
 * @return {object} - Normalized user data object
 */
export const normalizeUserData = ({
  userData,
  addRoles,
  addEmail,
}: {
  userData: any;
  addRoles: boolean;
  addEmail: string;
}) => {
  const normalizedData: any = {
    id: userData.id,
    first_name: userData.first_name,
    last_name: userData.last_name,
  };

  if (userData.image) normalizedData.image = userData.image;
  if (addEmail) normalizedData.email = userData.email;
  if (addRoles && userData.role_id) normalizedData.roles = [userData.role_id];
  if (userData.pin) normalizedData.pin = userData.pin;
  if (userData.password) {
    normalizedData.password = userData.password;
    normalizedData.password_confirmation = userData.password_confirmation;
  }

  return normalizedData;
};
